import { Component, OnInit } from '@angular/core';
import { UserService } from './shared/services/user.service';
import { CommonService } from './shared/services/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private userService: UserService,
    private commonService: CommonService
  ) {}
   ngOnInit() {
    this.userService.populate();
    this.commonService.initTermAndYear();
  }
}
